import { API_BASE_URL, FILES_BASE_URL } from './apiBase';

function normalizeMediaPath(value = '') {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw)) return raw;

  const normalized = raw.replace(/\\/g, '/');
  const uploadsMatch = normalized.match(/(?:^|\/)(uploads\/.+)$/i);
  if (uploadsMatch) {
    return `/${uploadsMatch[1].replace(/^\/+/, '')}`;
  }

  return ('/' + normalized).replace(/\/{2,}/g, '/');
}

export function mediaUrl(p = '') {
  if (!p) return '';
  const clean = normalizeMediaPath(p);
  if (/^https?:\/\//i.test(clean)) return clean;
  return (FILES_BASE_URL || '') + clean;
}

export { API_BASE_URL, FILES_BASE_URL };
